/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Source_All_CloudInputs */



/**
* | output |
* | --- |
* | "All cloud voices" |
*
* @param {Voice_Manager_Source_All_CloudInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_source_all_cloud = /** @type {((inputs?: Voice_Manager_Source_All_CloudInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Source_All_CloudInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les voix cloud")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Cloud-Stimmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutte le voci cloud")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все облачные голоса")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todas las voces en la nube")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有云端语音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのクラウド音声")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी क्लाउड आवाज़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todas as vozes na nuvem")
	return /** @type {LocalizedString} */ ("All cloud voices")
});